module.exports = __webpack_public_path__ + "static/media/hot_qnxz.6019aa4f.png";